<template>
    <div
         :style="`
         padding-right:${bodypadding}px;
         padding-left:${bodypadding}px;
         display:inline;width:100%;
         background-color: ${active?'beige':'transparent'};`">
        <div style="text-align: center;">
            <div :style="`display:inline-block; padding:${d.iconpadding}px`" v-for="s in d.socialselected" :key="s.type">
                <img :src="`${iconurl}${s}.png`" :height="d.iconheight" />
            </div>
        </div>
    </div>
</template>

<script>
  import{
    mapState
  } from 'vuex'
  export default {
    props:['d','active','bodypadding'],
    components: {},
    name: "Social",
    data() {
      return {
        socialicons:{
          twitter:'mdi-twitter-box',
          youtube:'mdi-youtube',
          facebook:'mdi-facebook-box',
          instagram:'mdi-instagram',
          linkedin:'mdi-linkedin-box',
          pinterest:'mdi-pinterest-box'
        },
        iconurl: 'https://18panelsadmin.s3-us-west-2.amazonaws.com/img/social/PNG/Circle+Color/'
      }
    },
    computed:{
      ...mapState(['icons','org'])
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>